import styled from 'styled-components'

export const Form = styled.form`
  margin-top: 16px;
`
export const Inline = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
